export default function CollectionIcon({ className="", onClick=null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M242.11,232.26V101.89c0-1.17-.95-2.13-2.12-2.13H93.87c-1.17,0-2.12.96-2.12,2.13v130.37c0,1.17.95,2.12,2.12,2.12h146.12c1.17,0,2.12-.95,2.12-2.12ZM118.39,207.73v-81.34h97.08v81.34h-97.08Z"/>
      <path d="M406.13,60.2h-130.37c-1.17,0-2.13.95-2.13,2.12v169.72c0,1.18.96,2.13,2.13,2.13h130.37c1.17,0,2.12-.95,2.12-2.13V62.32c0-1.17-.95-2.12-2.12-2.12ZM381.61,207.53h-81.34v-120.7h81.34v120.7Z"/>
      <path d="M214.62,437.67v-169.73c0-1.17-.96-2.12-2.13-2.12H82.13c-1.18,0-2.13.95-2.13,2.12v169.73c0,1.17.95,2.13,2.13,2.13h130.35c1.17,0,2.13-.96,2.13-2.13ZM106.65,413.15v-120.71h81.33v120.71h-81.33Z"/>
      <path d="M420,398.31v-130.37c0-1.17-.95-2.12-2.12-2.12h-169.73c-1.17,0-2.12.95-2.12,2.12v130.37c0,1.17.95,2.13,2.12,2.13h169.73c1.17,0,2.12-.96,2.12-2.13ZM272.66,373.78v-81.34h120.7v81.34h-120.7Z"/>
    </svg>
  );
}
